import consoleLogger from '../../../../../console-logger'

const getPinpollId = ({ element }) => {
  const [consoleLog] = consoleLogger('GetPinpollId')
  consoleLog('element', element, 'Pinpoll')
  if (!Array.isArray(element) && element.length <= 0) {
    consoleLog('element: ', 'not valid', 'Pinpoll')
    return
  }

  const parentElement = element[0]

  consoleLog('parentElement', parentElement, 'Pinpoll')

  return parentElement && parentElement.attribs['data-pinpoll-id']
}

export default getPinpollId
